import React, { Component } from 'react';
import { ComponentType } from 'react';
import { PhoneIcon, RadioIcon, RefreshCwIcon, SunIcon, ThermometerIcon, WrenchIcon, ZapIcon, ActivityIcon, BoxesIcon } from 'lucide-react';
import { categories, CONTACT } from '../../data/modalities';
import { SectionHeading } from './SectionHeading';
const icons: Record<string, ComponentType<{
  className?: string;
}>> = {
  'class-iv-laser': ZapIcon,
  shockwave: ActivityIcon,
  heit: RadioIcon,
  led: SunIcon,
  thermal: ThermometerIcon,
  'peptides-stem-cells': ActivityIcon,
  'used-equipment': RefreshCwIcon,
  concierge: BoxesIcon,
  'neuro-reformer': WrenchIcon
};
const categoryAnchorIds: Record<string, string> = {
  'class-iv-laser': 'category-class-iv-laser',
  shockwave: 'category-shockwave',
  heit: 'category-high-energy-inductive-therapy',
  led: 'category-whole-body-red-light-led-therapy',
  thermal: 'category-thermal-imaging',
  'peptides-stem-cells': 'category-peptides-stem-cells',
  'used-equipment': 'category-used-equipment',
  concierge: 'category-concierge-modality-suite',
  'neuro-reformer': 'category-neuro-reformer'
};
function EquipmentPanel({
  id,
  Icon
}: {
  id: string;
  Icon: ComponentType<{
    className?: string;
  }>;
}) {
  const label = id === 'used-equipment' ? 'PRE-OWNED' : id === 'concierge' ? 'CURATED SYSTEM' : 'TECHNOLOGY';
  return <div className="relative flex aspect-[4/3] items-center justify-center overflow-hidden border-b border-slate-100 bg-slate-50" data-id="element-628" data-mp="2v2fd11w5085a">
      <div className="absolute inset-x-8 top-1/2 h-px bg-teal/25" data-id="element-629" data-mp="2q3lz58cxuf4l" />
      <div className="absolute left-1/2 top-1/2 h-32 w-32 -translate-x-1/2 -translate-y-1/2 rounded-full border border-navy/10" data-id="element-630" data-mp="2m0pn60hwlh9m" />
      <div className="absolute left-1/2 top-1/2 h-20 w-20 -translate-x-1/2 -translate-y-1/2 rounded-full border border-teal/40" data-id="element-631" data-mp="2h1w6y0b8fc5r" />
      <div className="absolute flex h-20 w-28 items-center justify-center rounded-2xl border border-navy/15 bg-white shadow-[0_12px_28px_-18px_rgba(26,27,75,0.45)]" data-id="element-632" data-mp="1ajzca42jc19o">
        <div className="flex h-14 w-14 items-center justify-center rounded-xl bg-navy text-teal-light" data-id="element-633" data-mp="174xt6cg4xqky">
          <Icon className="h-7 w-7" data-id="element-634" data-mp="1c2zdt1t7lxyj" />
        </div>
      </div>
      <span className="absolute bottom-5 rounded-full border border-navy/10 bg-white/80 px-2.5 py-1 text-[10px] font-semibold tracking-[0.16em] text-navy/55" data-id="element-635" data-mp="y4hqv6b4opho">
        {label}
      </span>
      <span className="absolute left-8 top-7 h-2 w-2 rounded-full bg-teal" data-id="element-636" data-mp="odeqk6q0wejg" />
      <span className="absolute right-9 top-10 h-1.5 w-1.5 rounded-full bg-navy/30" data-id="element-637" data-mp="oc3qagvsdox3" />
    </div>;
}
export function Categories() {
  return <section id="products" className="w-full bg-white py-20 sm:py-24" data-id="element-638" data-mp="egs7nnh9bxk2">
      <div className="mx-auto max-w-7xl px-5 sm:px-8" data-id="element-639" data-mp="jek8x83skw0x">
        <SectionHeading eyebrow="Product Categories" title="Technologies to understand before you invest" description="Start with the category, then call JAG to compare product families, practical fit, training needs, and implementation considerations." data-id="element-640" data-mp="jf3hhy7jy82a" />
        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-641" data-mp="3my9m71w2omrc">
          {categories.map(category => {
          const Icon = icons[category.id] ?? ZapIcon;
          const categoryAnchorId = categoryAnchorIds[category.id];
          return <article id={categoryAnchorId} key={category.id} className="group flex h-full scroll-mt-[104px] flex-col overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-[0_2px_20px_-8px_rgba(26,27,75,0.14)] transition-[transform,border-color,box-shadow] duration-200 hover:-translate-y-1 hover:border-teal/40 hover:shadow-[0_18px_40px_-16px_rgba(26,27,75,0.25)]" data-id="element-642" data-mp="3rwkxzi5xh7c7">
                {category.image ? <div className={`relative flex aspect-[4/3] items-center justify-center overflow-hidden border-b border-slate-100 bg-slate-50 ${category.imageFit === 'cover' ? '' : 'p-6'}`} data-id="element-643" data-mp="shfupvt61s6z">
                    <img src={category.image} alt={category.imageAlt ?? category.name} className={`h-full w-full ${category.imageFit === 'cover' ? 'object-cover' : 'object-contain'}`} data-id="element-644" data-mp="2hy1oi1cs5wry" />
                  </div> : <EquipmentPanel id={category.id} Icon={Icon} data-id="element-645" data-mp="2vppwbsfzxz34" />}
                <div className="flex flex-1 flex-col p-6" data-id="element-646" data-mp="1z1a8q1wg5zsn">
                  <div className="flex items-start justify-between gap-3" data-id="element-647" data-mp="23ys8b1okr2nz">
                    <div className="flex items-center gap-2.5" data-id="element-648" data-mp="240wmqdk3nk2i">
                      <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-teal/10 text-teal" data-id="element-649" data-mp="27zvqhuu3hasd">
                        <Icon className="h-[18px] w-[18px]" data-id="element-650" data-mp="2d11hno83wpzs" />
                      </span>
                      <h3 className="font-display text-[17px] font-bold leading-tight text-navy" data-id="element-651" data-mp="3jfajknj6nii7">
                        {category.name}
                      </h3>
                    </div>
                  </div>
                  <p className="mt-3 text-[13.5px] leading-relaxed text-charcoal/75" data-id="element-652" data-mp="2co5ihpfwf83">
                    {category.detail}
                  </p>
                  <p className="mt-4 text-[11px] font-medium leading-relaxed text-slate-500" data-id="element-653" data-mp="3osinad3y7055">
                    {category.products.join(' · ')}
                  </p>
                  <a href={CONTACT.phoneHref} className="mt-5 inline-flex items-center gap-2 text-[13px] font-semibold text-navy transition-colors hover:text-teal focus-visible:outline-none focus-visible:text-teal" data-id="element-654" data-mp="3kpmc37gqm6b8">
                    <PhoneIcon className="h-4 w-4" data-id="element-655" data-mp="35ug62khn67hw" />
                    {category.ctaLabel ?? 'Call About This Category'}
                  </a>
                </div>
              </article>;
        })}
        </div>
      </div>
    </section>;
}